module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-red.8dce7f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-red.svg
// module id = XYEL
// module chunks = 82